import { ca } from '@cian/analytics';
import { getPageExtra } from '../../utils/tracking';
import { IProduct } from '../../types/tracking';
import { EDealType } from '../../utils/jsonQuery';

export const trackRecommendationsView = (dealType: EDealType, products?: IProduct[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_similar_offers',
    label: 'user-based',
    page: {
      extra: getPageExtra({ dealType }),
    },
    products,
  });
};

export const trackRecommendationsTrapView = (dealType: EDealType, type: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: type,
    action: 'show_sopr',
    label: 'recs_user_based',
    page: {
      extra: getPageExtra({ dealType, withEntrSource: true }),
    },
  });
};

export const trackRecommendationItemClick = (dealType: EDealType, products?: IProduct[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    page: {
      extra: getPageExtra({ dealType }),
    },
    products,
  });
};

export const trackTrapRecommendationClick = (dealType: EDealType, type: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: type,
    action: 'click',
    label: 'recs_user_based',
    page: {
      extra: getPageExtra({ dealType, withEntrSource: true }),
    },
  });
};
